import axios from 'axios'

interface GetCurrentUserResponse {
  email: string
  id: string
}

interface LoginResponse {
  user: GetCurrentUserResponse
  token: string
}

interface LoginRequest {
  email: string
  password: string
}

interface SetPasswordRequest {
  newPassword: string
  newPasswordConfirmation: string
}

class AuthService {
  async getCurrentUser(token: string) {
    try {
      const { data } = await axios.get<GetCurrentUserResponse>('/api/user', {
        headers: { Authorization: `Bearer ${token}` },
      })
      return data
    } catch (error) {
      console.error(error)
      throw new Error('AuthService -> getCurrentUser: Failed to fetch current user')
    }
  }

  async login(payload: LoginRequest) {
    try {
      const { data } = await axios.post<LoginResponse>('/api/auth/login', payload)

      return data
    } catch (error) {
      console.error(error)
      throw new Error('AuthService -> login: Failed to login')
    }
  }

  async forgotPassword(email: string) {
    try {
      const { data } = await axios.post<{ token: string }>('/api/auth/forgot-password', {
        email,
      })

      return data
    } catch (error) {
      console.error(error)
      throw new Error('AuthService -> forgotPassword: Failed to send forgot password')
    }
  }

  async setPassword(payload: SetPasswordRequest, token: string) {
    try {
      const { data } = await axios.post<{ success: boolean }>(
        `/api/auth/set-password/${token}`,
        payload,
      )

      return data
    } catch (error) {
      console.error(error)
      throw new Error('AuthService -> setPassword: Failed to set new password')
    }
  }
}

export default new AuthService()
